import { z } from 'zod'

import { dbEntitySchema, listQueryZodFields } from './system'
import { VenueTagType } from '../constants/venue'

export const baseTagSchema = z.object({
  name: z.string().trim(),
  key: z.nativeEnum(VenueTagType),
  value: z.string().trim(),
})

export const tagSchema = dbEntitySchema.extend(baseTagSchema.shape)

export const tagListQuerySchema = z.object({
  ...listQueryZodFields,
  type: z.nativeEnum(VenueTagType).optional().nullable(),
  name: z.string().optional().nullable(),
})

export const tagCreateSchema = tagSchema.omit({
  _id: true,
  id: true,
  deleted: true,
  created: true,
  modified: true,
})

export const tagUpdateByIdSchema = tagSchema.partial().omit({
  _id: true,
  id: true,
  created: true,
})

export const tagListResponseSchema = z.object({
  data: z.array(tagSchema),
  total: z.number(),
})
